import React from 'react';
import Plaintext from './plaintext';
import Text from './text';
import Helpers from 'utils/helpers';

export default function TextAreaInputWrapper(props) {
  if (props.plaintext || props.readOnly || props.readonly || props.disabled) {
    const value = Helpers.Object.exists(props.value) ? props.value : props.defaultValue;
    return (
      <Plaintext style={props.style}>
        {value.split('\n').map((v, i) => <div key={i}>{v}</div>)}
      </Plaintext>
    );
  }
  else {
    return <Text {...props} as='textarea' rows={props.rows || 3} />;
  }
}